<template>
  <footer class="bg-gray-900 text-white">
    <!-- Bottom Bar -->
    <div class="border-t border-gray-800">
      <div class="container-custom py-8">
        <!-- Contact Information -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          <!-- Company Info -->
          <div class="text-gray-300">
            <h3 class="text-white font-semibold mb-3">{{ $t('contact.company.name') }}</h3>
            <div class="space-y-2 text-sm">
              <p><span class="text-gray-400">電話：</span>(05) 2618 021</p>
              <p><span class="text-gray-400">傳真：</span>(05) 2617 858</p>
              <p><span class="text-gray-400">手機：</span>0937-438-842</p>
              <p><span class="text-gray-400">Email：</span>service@hongkai-green.com</p>
            </div>
          </div>

          <!-- Address -->
          <div class="text-gray-300">
            <h3 class="text-white font-semibold mb-3">聯絡地址</h3>
            <p class="text-sm text-gray-400 leading-relaxed">
              嘉義縣竹崎鄉和平村<br>
              坑仔坪160-3號
            </p>
          </div>

          <!-- Links and Social Media -->
          <div class="text-gray-300">
            <h3 class="text-white font-semibold mb-3">快速連結</h3>
            <div class="space-y-2">
              <div class="flex flex-col space-y-2">
                <a href="#privacy" class="text-gray-400 hover:text-white text-sm transition-colors">
                  {{ $t('footer.privacy') }}
                </a>
                <a href="#terms" class="text-gray-400 hover:text-white text-sm transition-colors">
                  {{ $t('footer.terms') }}
                </a>
                <button
                  @click="scrollToTop"
                  class="text-gray-400 hover:text-white text-sm transition-colors flex items-center space-x-1 w-fit"
                >
                  <span>{{ $t('footer.backToTop') }}</span>
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                  </svg>
                </button>
              </div>

              <!-- Social Media Icons -->
              <div class="flex items-center space-x-3 mt-4 pt-3 border-t border-gray-700">
                <a
                  href="https://line.me/R/ti/p/@btk0070q"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-gray-400 hover:text-green-400 transition-colors"
                  title="Line"
                >
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a
                  href="https://www.facebook.com/Outdoor.shade"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-gray-400 hover:text-blue-400 transition-colors"
                  title="Facebook"
                >
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Copyright -->
        <div class="border-t border-gray-700 pt-6">
          <div class="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p class="text-gray-400 text-sm">
              &copy; 2025 {{ $t('contact.company.name') }}. {{ $t('footer.copyright') }} |
              <span class="text-gray-500">{{ $t('contact.company.taxId') }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  setup() {
    // Scroll to top
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    return {
      scrollToTop
    }
  }
}
</script>

<style scoped>
/* Footer specific styles */
footer {
  position: relative;
}

/* Smooth hover transitions */
footer a {
  transition: all 0.2s ease-in-out;
}

/* Button hover effects */
footer button:hover {
  transform: translateY(-1px);
}
</style>